import type {
  HomeCuentaImagenBannerRow,
  HomeCuentaImagenesContent,
} from '../models/home-cuenta-imagenes-content.model';

/** orden 0 = PN, orden 1 = PJ */
export const CUENTA_ORDEN_NATURAL = 0;
export const CUENTA_ORDEN_JURIDICA = 1;

export const CUENTA_IMAGE_NATURAL_FALLBACK =
  'assets/img/Home/cuenta/cuenta-registro-natural.png';
export const CUENTA_IMAGE_JURIDICA_FALLBACK =
  'assets/img/Home/cuenta/cuenta-registro-juridica.png';

export function mapCuentaImagenesBannersToContent(
  rows: HomeCuentaImagenBannerRow[],
  fallback: HomeCuentaImagenesContent
): HomeCuentaImagenesContent {
  const sorted = [...rows].sort(
    (a, b) => Number(a.orden ?? 0) - Number(b.orden ?? 0)
  );
  const natural = sorted.find((r) => Number(r.orden) === CUENTA_ORDEN_NATURAL);
  const juridica = sorted.find((r) => Number(r.orden) === CUENTA_ORDEN_JURIDICA);

  return {
    naturalSrc: natural?.urlArchivo?.trim() || fallback.naturalSrc,
    juridicaSrc: juridica?.urlArchivo?.trim() || fallback.juridicaSrc,
  };
}
